export interface RuntimeConfig {
  API_BASE_URL: string;
  RAWFILE_CONTAINER_NAME: string;
  FASTA_CONTAINER_NAME: string;
  OMICSFLOW_GENERAL_VERSION: string;
}

export const runtimeConfig = {} as RuntimeConfig;

export async function loadRuntimeConfig() {
  const res = await fetch("/config.json", { cache: "no-store" });
  const config: RuntimeConfig = await res.json();
  Object.assign(runtimeConfig, config);
}
